import React from 'react'
import { ConfigClientType } from '../types/ConfigClientType'
import { VisibilityType } from '../types/VisibilityType'
import { getOpeningHours } from './openinghours/hours'
import { getTranslation } from '../../constants/languages'
import { getPageExceptionTranslation } from '../../constants/siteIds'

type CallClosedStatusProps = {
  iimclient: ConfigClientType;
  visibility: VisibilityType;
}

const Translations = {
  lang_no: hours => '',      // 'Kundeservice er nå stengt.',
  lang_se: hours => '',      // 'Kundservice är nu stängd.',
  lang_dk: hours => '',      // 'Kundecenteret er lukket',
  lang_fi: hours => 'Asiakaspalvelu on nyt suljettu.',
  lang_en: hours => 'Customer service is now closed.', // `Customer service is now closed. Opens at ${hours}. Have you received a claim or needhelp immediately, you can call us 24/7.`
}

const CallClosedStatus = ({ iimclient, visibility }: CallClosedStatusProps) => {
  const { lang } = iimclient;
  const { callClosedVisible } = visibility;

  const openingHours = getOpeningHours(lang);
  const translation = getTranslation(lang, Translations)(openingHours);
  
  // Left this as is, but need to change this to utilise the opening hours later on
  const isVisible = translation !== '' && callClosedVisible

  return isVisible && (
    <p className="whenclosed callusstatus">
      {translation}
    </p>
  );
}

export default CallClosedStatus